import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  getDecisionNodeAtPath,
  extractSelectedTicketFromState,
  getNewMessagesEditor,
  extractNonHistoricalTicketIdFromState,
} from '../../../../../../extractFromState';
import { trackButtonClick, BUTTONS } from '../../../../../../analytics/buttonEventAnalytics';
import {
  ExpertQuestionSection,
  Title,
  QuestionAction,
  QuestionHeader,
  QuestionText,
  QuestionWrapper,
  SubText,
} from '../../DTQuestionOrInstruction.styles';
import { convertToRaw } from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import { messageToClientFormat } from '../../../../../../util';
import { DraftHelpers } from '../../../../../../util/Draft';
import { onPasteText, saveNewMessageEditorState } from '../../../../../../actions';
import CopyToChatButton from './CopyToChatButton';

const Question = () => {
  const decisionNode = useSelector(getDecisionNodeAtPath);
  const selectedTicket = useSelector(extractSelectedTicketFromState);
  const selectedConversationId = useSelector(extractNonHistoricalTicketIdFromState);
  const editorState = useSelector(getNewMessagesEditor);
  const dispatch = useDispatch();

  const handleClickCopyButton = () => {
    const { ticketType, communicationType } = selectedTicket;

    const text = messageToClientFormat(decisionNode.copyText, ticketType, communicationType);
    const newEditorState = DraftHelpers.appendHtmlToContents(text, editorState);
    dispatch(saveNewMessageEditorState(selectedConversationId, newEditorState, false));
    const newContentState = newEditorState.getCurrentContent();
    const raw = convertToRaw(newContentState);
    const newHtml = draftToHtml(raw);
    dispatch(onPasteText(newHtml));
    trackButtonClick(BUTTONS.COPY_SUB_TEXT);
  };

  if (decisionNode?.subText || decisionNode?.title) {
    return (
      <ExpertQuestionSection>
        {decisionNode.title && <Title>{decisionNode.title}</Title>}
        {decisionNode.subText && <SubText>{decisionNode.subText}</SubText>}
        {!!decisionNode.copyText && (
          <QuestionWrapper>
            <QuestionHeader>Ask Customer</QuestionHeader>
            <QuestionText>{decisionNode.copyText}</QuestionText>
            <QuestionAction>
              <CopyToChatButton onClick={handleClickCopyButton} />
            </QuestionAction>
          </QuestionWrapper>
        )}
      </ExpertQuestionSection>
    );
  }

  return null;
};

export default Question;
